import { render } from "./sales-list-modal.vue?vue&type=template&id=79ca95b2"
import script from "./sales-list-modal.vue?vue&type=script&lang=js"
export * from "./sales-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__